export function EmptySeat({ seat, canSit, onSit, pendingNickname }: {
  seat: number; canSit: boolean; onSit: (seat: number) => void; pendingNickname: string | null;
}) {
  if (pendingNickname) {
    return (
      <div className="seatbox pending" data-testid={`seat-empty-${seat}`}>
        <span className="seat-plate" aria-hidden="true" />
        <div className="seat-status"><span className="avatar-ring"><span className="avatar" aria-hidden="true">…</span></span><span className="caption">REQUESTED</span></div>
        <div className="seat-id"><span className="seat-name">{pendingNickname}</span></div>
      </div>
    );
  }
  if (canSit) {
    return (
      <button type="button" className="seat-empty sit" data-testid={`seat-empty-${seat}`} aria-label={`Sit at seat ${seat + 1}`} onClick={() => onSit(seat)}>
        <span className="seat-plus" aria-hidden="true">+</span>
        <span className="sit-here">SIT<span className="here"> HERE</span></span>
      </button>
    );
  }
  return <div className="seat-empty" data-testid={`seat-empty-${seat}`}><span className="seat-plus num">{seat + 1}</span></div>;
}
